import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { PlainTable, HorizontalTable, Pagination } from '@mdc/ui';

import './StackTable.scss';

const StackTable = ({ data, className, isHorizontal }) => {
    const [noOfItemsPerPage, setNoOfItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [tableData, setTableData] = useState(data.slice(0, noOfItemsPerPage));

    const handleItemsPerPage = (key) => {
        setNoOfItemsPerPage(parseInt(key));
    };

    const handleSetCurrentPage = (key) => {
        setCurrentPage(parseInt(key));
    };

    useEffect(() => {
        setTableData(data.slice(noOfItemsPerPage * (currentPage - 1), currentPage * noOfItemsPerPage));
    }, [noOfItemsPerPage, data, currentPage]);

    const parsePlainTableData = (data) => {
        const rowData = {};
        const metadata = [];
        data.forEach((col, index) => {
            rowData['col' + index] = typeof col.data === 'number' && col.data === 0 ? '0' : col.data;
            metadata.push({
                Header: col.field,
                accessor: 'col' + index
            });
        });

        return { data: [rowData], metadata };
    };

    const tableDom = useMemo(() => {
        return tableData.map((row, index) => {
            let table;
            if (!isHorizontal) {
                const plainTableData = parsePlainTableData(row);
                table = <PlainTable data={plainTableData.data} columnsData={plainTableData.metadata}/>;
            } else {
                table = <HorizontalTable data={row}/>;
            }

            return <div className='stackTableContainer' key={index}>
                <h4>
                    {row.title}
                </h4>
                <div className='stackTableWrapper'>
                    {table}
                </div>
            </div>;
        });
    }, [tableData]);

    const pagination = useMemo(() => {
        return <Pagination
            dataLength={data.length}
            itemsPerPage={noOfItemsPerPage}
            onItemsPerPageClick={handleItemsPerPage}
            currentPage={currentPage}
            setCurrentPage={handleSetCurrentPage}
        />;
    }, [data, noOfItemsPerPage, currentPage]);

    return <div className={`${className || ''} stackTable`}>
        {tableDom}
        {pagination}
    </div>;
};

StackTable.propTypes = {
    data: PropTypes.array.isRequired,
    className: PropTypes.string,
    isHorizontal: PropTypes.bool,
};

export default StackTable;
